export default __webpack_public_path__ + "static/sedex-smeta-f3b0e0d2e4759a905fb78d335eb1bb82.png";